// 展示頁面翻譯

export const showcase = {
    title: 'Catoo Showcase',
    subtitle: 'Explore various types of image processing effects and experience the power of professional AI technology.',
    loadError: 'Failed to load showcase images, please try again later',
    featured: 'Featured',
    downloadStarted: 'Download started',
    generatedImage: 'Generated image',
    noTitle: 'No title',
    noMoreImages: 'No more images to load',
    noImagesFound: 'No showcase images found',
    noImagesDescription: 'There are no showcase images available at the moment. Check back later for new content!'
  };
